import React from "react";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { InLineLabel } from "./Label";

interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  label?: React.ReactNode;
}

export const CardHeader = ({
  title,
  children,
  subtitle,
  label,
  ...rest
}: CardHeaderProps) => {
  return (
    <div
      className={`card-header border-bottom-0 mt-4 ${
        children ? "justify-content-between" : ""
      }`}
      {...rest}
    >
      <div className="d-flex flex-column" style={{ gap: "8px" }}>
        <div className="d-flex">
          <StyledText
            color={colors.textPrimary}
            className="bodyHeaderOneSemi mb-0"
          >
            {title}
          </StyledText>
          {label && (
            <InLineLabel
              backgroundColor={colors.ctaLight}
              color={colors.ctaMain}
              style={{ marginLeft: "8px" }}
            >
              {label}
            </InLineLabel>
          )}
        </div>
        {subtitle && (
          <StyledText
            color={colors.textPrimary}
            className="bodyTextRegular mb-0"
          >
            {subtitle}
          </StyledText>
        )}
      </div>
      {children}
    </div>
  );
};
